import React from "react";
import { Book } from "lucide-react";

interface FeatureItemProps {
    text: string;
}

const FeatureItem: React.FC<FeatureItemProps> = ({ text }) => {
    return (
        <li className="flex gap-4 items-start mb-1 text-lg leading-7 text-white max-sm:text-sm max-sm:leading-5">
            <i className="ti ti-book text-1xl text-lime-50" />
            <span className="flex-1">{text}</span>
        </li>
    );
};

export default FeatureItem;